// path: src/shared/components/ui/ExpandToggle.tsx
import React from 'react';
import clsx from 'classnames';

interface ExpandToggleProps {
  isExpanded: boolean;
  /** Now receives the MouseEvent so callers can stopPropagation */
  onToggle: (e: React.MouseEvent<HTMLButtonElement>) => void;
}


export default function ExpandToggle({ isExpanded, onToggle }: ExpandToggleProps) {
  return (
    <button
      onClick={onToggle}
      className="p-1 focus:outline-none"
      aria-label={isExpanded ? 'Collapse row' : 'Expand row'}
    >
      <svg
        className={clsx(
          'w-4 h-4 transition-transform duration-200',
          isExpanded ? 'rotate-90' : 'rotate-0'
        )}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        {/* A right-pointing arrow that rotates downwards when expanded */}
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
      </svg>
    </button>
  );
}
